'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GlobalFunction = exports.GlobalFunction = function GlobalFunction() {
  window.urlObject = parseURL(window.location.search);
  // revealHeaderMainRow = () => {
  //     $('.header-main-row--hidden').removeClass('header-main-row--hidden');
  // };
};

// eslint-disable-next-line func-style
var parseURL = function parseURL(url) {
  var parser = document.createElement('a');
  var searchObject = {};
  var queries = '';
  var split = '';
  var i = '';

  // Let the browser do the work

  parser.href = url;
  // Convert query string to object
  queries = parser.search.replace(/^\?/, '').split('&');
  for (i = 0; i < queries.length; i++) {
    split = queries[i].split('=');
    searchObject[split[0]] = split[1];
  }

  return {
    protocol: parser.protocol,
    host: parser.host,
    hostname: parser.hostname,
    port: parser.port,
    pathname: parser.pathname,
    search: parser.search,
    searchObject: searchObject,
    hash: parser.hash
  };
};